﻿
import { GroCommon } from './common';
import GroTranslator from './translator';

function isValidate(selector) {
    var isValid = $(selector).val() !== "True";
    if (!isValid) {
        $(selector).val('False');
    }
    return isValid;
}

if ($.validator) {
    $.validator.addMethod("CustomerNumberNotMatch", function (value, element, selector) {
        return isValidate(selector);
    }, "Kundnumret du har angett finns inte registrerat hos Lantmännen för det organisationsnummer du har angett.");
    $.validator.addMethod("CustomerNumberNotExist", function (value, element, selector) {
        return isValidate(selector);
    }, 'Kundnumret finns inte registrerat hos Lantmännen.');
    $.validator.addMethod("CustomerNumberActivated", function (value, element, selector) {
        return isValidate(selector);
    }, 'Kundnumret och organisationsnumret  du har angett är redan aktiverat för ett konto i LM2.');
    $.validator.addMethod("OrganisationNumberNotMatch", function (value, element, selector) {
        return isValidate(selector);
    }, 'Organisationsnumret du har angett stämmer inte överens med kundnumret du har angett.');
    $.validator.addMethod("OrganisationNumberActivated", function (value, element, selector) {
        return isValidate(selector);
    }, 'Organisationsnumret och kundnumret du har angett är redan aktiverat för ett konto i LM2.');
}

$(function () {
    ActiveFarmdayCustomer.checkIfValidAndIfYesDisableAfterSubmitToPreventMultipleClicks();
    ActiveFarmdayCustomer.init();
    ActiveFarmdayCustomer.initEvent();
    ActiveFarmdayCustomer.initValidateTermOfUseForm();
});

var ActiveFarmdayCustomer = ActiveFarmdayCustomer || (function () {
    var checkIfValidAndIfYesDisableAfterSubmitToPreventMultipleClicks = function() {
        $("#activation-step-1").submit(function() {
            if ($("#activation-step-1").valid()) {
                $('#verification-submit-button').prop("disabled", true);
            }
        });
        $("#activation-form").submit(function() {
            if ($("#activation-form").valid()) {
                $('#submit-button').prop("disabled", true);
            }
        });
    };

    var init = function () {
        if ($().validate) {
            $('#verifyCustomer').validate({
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    CustomerNumber: {
                        required: true,
                        regex: /^\d*$/,
                        CustomerNumberNotMatch: '#CustomerNumberNotMatch',
                        CustomerNumberNotExist: '#CustomerNumberNotExist',
                        CustomerNumberActivated: '#CustomerNumberActivated'
                    },
                    OrganisationNumber: {
                        required: true,
                        regex: /^\d{6}[-]{0,1}\d{4}$/,
                        OrganisationNumberNotMatch: '#OrganisationNumberNotMatch',
                        OrganisationNumberActivated: '#OrganisationNumberActivated'
                    }
                },
                messages: {
                    CustomerNumber: {
                        required: GroTranslator.get("/common/validation/customerNumber/required"),
                        regex: GroTranslator.get("/common/registration/error/errorcustomer")
                    },
                    OrganisationNumber: {
                        required: GroTranslator.get("/common/validation/organizationNumber/required"),
                        regex: GroTranslator.get("/common/registration/error/errororganisation")
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $('div.errors-list').hide();
                    $('ul.errors-list').show();
                    $('li#p_' + $(element).attr('id')).show();
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    $('li#p_' + $(element).attr('id')).hide();
                    if ($('ul.errors-list').find('li[id^="p"]').is(":visible") === false) {
                        $('ul.errors-list').hide();
                    }
                },
                submitHandler: function (form) {
                    $('#loader').show();
                    $('#loader').parent().addClass('disabled');
                    form.submit();
                }
            });
        }

        if ($().validate) {
            var isInvalid = $('#CustomerNumberNotMatch').val() === "True" ||
                $('#CustomerNumberNotExist').val() === "True" ||
                $('#CustomerNumberActivated').val() === "True" ||
                $('#OrganisationNumberNotMatch').val() === "True" ||
                $('#OrganisationNumberActivated').val() === "True";
            if (isInvalid) {
                $("#verifyCustomer").valid();
            }
        }
    };

    var initEvent = function () {
        var submitted;

        if ($(".js-page-identifier-activation-step-1").length) {

            $("#activation-step-1").validate({
                errorElement: 'div',
                errorClass: "error",
                rules: {
                    customerNumber: {
                        required: true,
                        regex: /^\d*$/i
                    },
                    organizationNumber: { // TODO, change for finnish org nr as well, also letters
                        required: true,
                        regex: /^[a-zA-Z0-9_.-]*$/
                    }
                },
                messages: {
                    customerNumber: {
                        required: GroTranslator.get("/common/validation/customerNumber/required"),
                        regex: GroTranslator.get("/common/registration/error/errorcustomer")
                    },
                    organizationNumber: {
                        required: GroTranslator.get("/common/validation/organizationNumber/required"),
                        regex: GroTranslator.get("/common/registration/error/errororganisation")
                    }
                },
                showErrors: function (errorMap, errorList) {
                    if (submitted) {
                        submitted = false;

                        //set top error alert box
                        var errorListElement = $("#errors-list");
                        if (errorList.length > 0) {
                            errorListElement.css("display", "block");
                            $("#errors-list .error-list-item").each(function (idx, eli) {
                                var display = errorMap[$(eli).data("for")] ? "block" : "none";
                                $(eli).css("display", display);
                            });
                        }
                    }

                    this.defaultShowErrors();
                },
                invalidHandler: function (form, validator) {
                    submitted = true;
                }
            });
        }

        if ($(".js-page-identifier-activation-non-private").length) {
            submitted = false;

            $("#activation-form").validate({
                errorElement: 'div',
                errorClass: "error",
                rules: {
                    FirstName: "required",
                    LastName: "required",
                    Email: {
                        required: true,
                        regex: /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
                    },
                    Telephone: {
                        phoneSE: true
                    },
                    Mobilephone: {
                        required: true,
                        mobileSE: true
                    },
                    AcceptTerms: {
                        required: true
                    },
                    PaymentResponsibility: {
                        required: true
                    }
                },

                messages: {
                    FirstName: window["validationMessage"].firstName.required,
                    LastName: window["validationMessage"].lastName.required,
                    Telephone: {
                        phoneSE: window["validationMessage"].phoneSE.valid
                    },
                    Mobilephone: {
                        required: window["validationMessage"].mobileSE.required,
                        mobileSE: window["validationMessage"].mobileSE.valid
                    },
                    Email: {
                        required: window["validationMessage"].email.required,
                        regex: window["validationMessage"].email.valid
                    },
                    AcceptTerms: {
                        required: GroTranslator.get("/common/validation/termsofuse/required")
                    },
                    PaymentResponsibility: {
                        required: "Du måste godkänna betalningsansvar"
                    }
                },

                showErrors: function (errorMap, errorList) {
                    if (submitted) {
                        console.log(errorMap);
                        console.log(errorList);
                        submitted = false;

                        ////set top error alert box
                        var errorListElement = $("#errors-list");
                        if (errorList.length > 0) {
                            errorListElement.css("display", "block");
                            $("#errors-list .error-list-item").each(function (idx, eli) {
                                var display = errorMap[$(eli).data("for")] ? "block" : "none";
                                $(eli).css("display", display);
                            });
                        }
                    }

                    this.defaultShowErrors();
                },
                invalidHandler: function (form, validator) {
                    submitted = true;
                }
            });

            var emailerror = $("#EmailError").val();

            if (emailerror) {
                $("#errors-list").css("display", "block");
                $("#errors-list .error-list-item").css("display", "none");
                $("#jsEmailError").css("display", "block");
            }

            $("#cancel-button").click(function () {
                var cancelDialog = $("#cancel-dialog");
                cancelDialog.css("display", "block");
            });

            $("#cancel-accept").click(function () {
                var url = $(".js-page-identifier-activation-non-private").data("cancel-url");
                window.location.href = url;
            });
        }

        if ($(".js-page-identifier-activation-private").length) {

            submitted = false;

            $("#activation-form").validate({
                errorElement: 'div',
                errorClass: "error",
                rules: {
                    FirstName: "required",
                    LastName: "required",
                    Telephone: {
                        phoneSE: true
                    },
                    Mobilephone: {
                        required: true,
                        mobileSE: true
                    },
                    Email: {
                        required: true,
                        regex: /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
                    },
                    AcceptTerms: {
                        required: true
                    },
                    PaymentResponsibility: {
                        required: true
                    }
                },

                messages: {
                    FirstName: window["validationMessage"].firstName.required,
                    LastName: window["validationMessage"].lastName.required,
                    Telephone: {
                        phoneSE: window["validationMessage"].phoneSE.valid
                    },
                    Mobilephone: {
                        required: window["validationMessage"].mobileSE.required,
                        mobileSE: window["validationMessage"].mobileSE.valid
                    },
                    Email: {
                        required: window["validationMessage"].email.required,
                        regex: window["validationMessage"].email.valid
                    },
                    AcceptTerms: {
                        required: GroTranslator.get("/common/validation/termsofuse/required")
                    },
                    PaymentResponsibility: {
                        required: "Du måste godkänna betalningsansvar"
                    }
                },

                invalidHandler: function (form, validator) {
                    submitted = true;
                },

                highlight: function (element, errorClass) {
                    $(element).addClass(errorClass);
                },

                showErrors: function (errorMap, errorList) {
                    if (submitted) {
                        submitted = false;

                        ////set top error alert box
                        var errorListElement = $("#errors-list");
                        if (errorList.length > 0) {
                            errorListElement.css("display", "block");
                            $("#errors-list .error-list-item").each(function (idx, eli) {
                                var display = errorMap[$(eli).data("for")] ? "block" : "none";
                                $(eli).css("display", display);
                            });
                        }
                    }

                    this.defaultShowErrors();
                }
            });
            var emailerror = $("#EmailError").val();
            if (emailerror) {
                $("#errors-list").css("display", "block");
                $("#errors-list .error-list-item").css("display", "none");
                $("#jsEmailError").css("display", "block");
            }

            $("#cancel-button").click(function () {
                var cancelDialog = $("#cancel-dialog");
                cancelDialog.css("display", "block");
            });

            $("#cancel-accept").click(function () {
                var url = $(".js-page-identifier-activation-non-private").data("cancel-url");
                window.location.href = url;
            });
        }

        var isDebug;

        if ($(".js-page-identifier-registration-non-private").length) {
            isDebug = $(".js-page-identifier-registration-non-private").data("debug");

            if (GroCommon.parseBool(isDebug)) {
                $.getScript("/Static/dist/scripts/nonPrivateFirmRegistration.js");
            } else {
                $.getScript("/Static/dist/scripts/nonPrivateFirmRegistration.production.js");
            }
        }

        if ($(".js-page-identifier-registration-private").length) {
            isDebug = $(".js-page-identifier-registration-private").data("debug");

            if (GroCommon.parseBool(isDebug)) {
                $.getScript("/Static/dist/scripts/privateFirmRegistration.js");
            } else {
                $.getScript("/Static/dist/scripts/privateFirmRegistration.production.js");
            }
        }
    };


    var initValidateTermOfUseForm = function () {
        if ($().validate) {
            $('#registerCustomer').validate({
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    ContractApplication: {
                        required: true
                    },
                    CopyOfIDDocuments: {
                        required: true
                    },
                    RegistrationCertificate: {
                        required: true
                    },
                    FirstName: {
                        required: true
                    },
                    SurName: {
                        required: true
                    },
                    Telephone: {
                        regex: /^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/
                    },
                    Mobile: {
                        required: true,
                        regex: /^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/
                    },
                    PersonNumber: {
                        required: true,
                        regex: /^[0-9]{12}$/
                    }
                },
                messages: {
                    ContractApplication: {
                        required: "Du måste bifoga ansökan om avtal för e-tjänster"
                    },
                    CopyOfIDDocuments: {
                        required: "Du måste bifoga Kopia på ID-handlingar"
                    },
                    RegistrationCertificate: {
                        required: "Du måste bifoga Registreringsbevis för ditt företag"
                    },
                    FirstName: {
                        required: "Förnamn är obligatorisk"
                    },
                    SurName: {
                        required: "Efternamn är obligatoriskt"
                    },
                    Telephone: {
                        regex: "Ange en giltig telefonnummer"
                    },
                    Mobile: {
                        required: "Mobilnr är obligatoriskt",
                        regex: "Ange ett giltigt mobilnummer"
                    },
                    PersonNumber: {
                        required: "Personnr är obligatoriskt",
                        regex: "Personnr måste bestå av 12 siffror"
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $('div.errors-list').hide();
                    $('ul.errors-list').show();
                    $('li#p_' + $(element).attr('id')).show();
                    var typeElement = $(element).attr('type');
                    if (typeElement === 'file') {
                        $(element).parent().addClass(this.settings.errorElementClass).removeClass(errorClass);
                    } else {
                        $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                    }

                },
                unhighlight: function (element, errorClass, validClass) {
                    var typeElement = $(element).attr('type');
                    if (typeElement === 'file') {
                        $(element).parent().removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    } else {
                        $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    }

                    $('li#p_' + $(element).attr('id')).hide();
                    if ($('ul.errors-list').find('li[id^="p"]').is(":visible") === false) {
                        $('ul.errors-list').hide();
                    }
                },
                errorPlacement: function (error, element) {
                    var typeElement = element.attr('type');
                    if (typeElement === 'file') {
                        element.parent().after(error);
                    } else {
                        element.after(error);
                    }

                }
            });
        }
    };

    return {
        checkIfValidAndIfYesDisableAfterSubmitToPreventMultipleClicks: checkIfValidAndIfYesDisableAfterSubmitToPreventMultipleClicks,
        init: init,
        initEvent: initEvent,
        initValidateTermOfUseForm: initValidateTermOfUseForm
    };
})();
